import styles from "./index.css";
import image1 from "./image1.jpg";
import image2 from "./image2.jpg";
import image3 from "./image3.jpg";
import logo from "./logo.png";
import classNames from "classnames";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";
import LoyaltyOptInModalButtons from "./LoyaltyOptInModalButtons";
import shouldShowModal from "./shouldShowModal";
import redirect from "./redirect";
import BottomLinks from "./BottomLinks";
import NoisyText from "./NoisyText";
import useOverflowControl from "./useOverflowControl";

const LoyaltyOptInModal = ({
  categoryId,
  loyaltyIsEnabled,
  loyaltyIsInvited,
  loyaltyIsOptedIn,
  loyaltyOptIn,
  analyticsLoyaltyOptInClick,
  analyticsLoyaltyOptInReject,
  formatTranslation
}) => {
  const showModal = shouldShowModal({
    categoryId,
    loyaltyIsEnabled,
    loyaltyIsInvited,
    loyaltyIsOptedIn
  });

  useOverflowControl(showModal);

  if (!showModal) {
    return null;
  }

  return (
    <div className={styles.loyaltyOptInModal}>
      <div className={styles.container}>
        <img
          alt={formatTranslation("quick_join_overlay_a11y_logo")}
          src={logo}
          className={styles.logo}
        />
        <div className={styles.headerContainer}>
          <ul className={styles.images}>
            <li className={styles.imageContainer}>
              <img alt="" src={image1} className={styles.image} />
              <div className={styles.padlock}></div>
            </li>
            <li className={styles.imageContainer}>
              <img alt="" src={image2} className={styles.image} />
              <div className={styles.padlock}></div>
            </li>
            <li className={styles.imageContainer}>
              <img alt="" src={image3} className={styles.image} />
              <div className={styles.padlock}></div>
            </li>
          </ul>
          <NoisyText />
        </div>
        <div className={classNames("leavesden1", styles.copy)}>
          {formatTranslation("quick_join_overlay_body_web")}
        </div>
        <LoyaltyOptInModalButtons
          loyaltyOptIn={() => {
            analyticsLoyaltyOptInClick();

            return loyaltyOptIn();
          }}
          loyaltyReject={() => {
            analyticsLoyaltyOptInReject();
            redirect();
          }}
        />
        <BottomLinks />
      </div>
    </div>
  );
};

LoyaltyOptInModal.propTypes = {
  categoryId: PropTypes.number,
  loyaltyIsEnabled: PropTypes.bool,
  loyaltyIsInvited: PropTypes.bool,
  loyaltyIsOptedIn: PropTypes.bool,
  loyaltyOptIn: PropTypes.func.isRequired,
  analyticsLoyaltyOptInClick: PropTypes.func.isRequired,
  analyticsLoyaltyOptInReject: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(LoyaltyOptInModal);
